import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  images = ['RamanandDas'].map((n) => `assets/owner/${n}.webp`);
  constructor() { }

  ngOnInit(): void {
  }

}
